import 'simplebar-react/dist/simplebar.min.css'

import { SCHOOL_TYPE_KO_ABBR } from '@mathflat/domain/@entities/SchoolSystem/constants'
import { observer } from 'mobx-react'
import { useEffect } from 'react'
import SimpleBar from 'simplebar-react'

import { useStudentAppMediaQuery } from '~/@common/hooks/useMediaQuery'
import { useRepository } from '~/@common/hooks/useRepository'
import authService from '~/@common/services/auth.service'
import modalService from '~/@common/services/modal.service'
import { commonRepo } from '~/@common/services/repo.service'
import { localStorageService } from '~/@common/services/storage.service'
import { colors } from '~/@common/styles'
import { Icon } from '~/@common/ui/Icon/Icon'
import Modal from '~/@common/ui/modal/Modal'
import PasswordChangeModal from '~/@pages/@widgets/PasswordChangeModal'

import { ParentProfileService } from './ParentProfile.service'
import { S } from './ParentProfile.style'

const ParentProfile = observer(() => {
  const { isMobile } = useStudentAppMediaQuery()
  const service = useRepository(ParentProfileService)

  const childStudentIds = commonRepo.parent.childStudents.map((c) => c.studentId)

  useEffect(() => {
    service.fetchChildren(childStudentIds as string[])
  }, [childStudentIds.join(','), service])

  const parentLoginId = localStorageService.user.beforeLoginId

  const handlePasswordChange = () => {
    modalService.openModal(
      {
        content: <PasswordChangeModal />,
        header: '비밀번호 변경',
      },
      {
        modalName: '비밀번호 변경',
        hasCloseButton: isMobile,
        headerOption: { hasBottomBorder: false },
      },
    )
  }

  const handleLogout = () => {
    modalService.openModal(
      <Modal.Confirm.Negative
        cancel={{ children: '취소' }}
        confirm={{
          onClick: () => {
            authService.logout()
            modalService.closeModal()
          },
          children: '로그아웃',
        }}
      >
        로그아웃 하시겠습니까?
      </Modal.Confirm.Negative>,
      { modalName: '로그아웃 모달' },
    )
  }

  return (
    <S.Wrapper>
      <S.ParentCard>
        <div className="card-box">
          <div className="card-content">
            <p className="label">아이디</p>
            <p className="value">{parentLoginId}</p>
          </div>
          <div className="button-container">
            <button className="action-button" onClick={handlePasswordChange}>
              <Icon name="icon_edit" size={18} color={colors.gray.$700} />
              <p>비밀번호 변경</p>
            </button>
            <button className="action-button" onClick={handleLogout}>
              <Icon name="icon_unlock" size={18} color={colors.gray.$700} />
              <p>로그아웃</p>
            </button>
          </div>
        </div>
      </S.ParentCard>

      <S.ChildSection>
        <p className="section-title">자녀 정보</p>
        <SimpleBar style={{ flex: 1, height: 0 }}>
          <S.ChildList>
            {service.children.map((child) => (
              <S.ChildCard key={child.id}>
                <div className="card-box">
                  <div className="card-content">
                    <p className="child-name">{child.name}</p>
                    <div className="info">
                      <div className="info-label">
                        <p>학년</p>
                        <p>아이디</p>
                        <p>출석 번호</p>
                      </div>
                      <div className="info-value">
                        <p>
                          {SCHOOL_TYPE_KO_ABBR[child.schoolType]}
                          {child.grade}
                        </p>
                        <p>{child.loginId}</p>
                        <p>{child.attendanceCode}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </S.ChildCard>
            ))}
          </S.ChildList>
        </SimpleBar>
      </S.ChildSection>
    </S.Wrapper>
  )
})

export default ParentProfile
